import { render, staticRenderFns } from "./sAside.vue?vue&type=template&id=cbb8b946&scoped=true&"
import script from "./sAside.vue?vue&type=script&lang=js&"
export * from "./sAside.vue?vue&type=script&lang=js&"
import style0 from "./sAside.vue?vue&type=style&index=0&id=cbb8b946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb8b946",
  null
  
)

export default component.exports